import { mutate } from '../../apollo/client';
import { logException } from '../distantLogger';

const EVENT_LOG_MISSION_VIEWED = 'MissionViewedLog';

const AVAILABLE_EVENTS = [EVENT_LOG_MISSION_VIEWED];

class EventLogDispatcher {
  /**
   * @param {string} event
   * @param {Object} linkedWith
   * @param {Object} details
   */
  static async dispatch(event, linkedWith = {}, details = {}) {
    if (!EventLogDispatcher._validate(event)) {
      return;
    }

    const { default: mutation } = await import('./EventLogMutation');

    const variables = {
      eventLog: {
        name: event,
        details: JSON.stringify(details),
        linkedWith: JSON.stringify(linkedWith)
      }
    };

    await mutate(mutation, variables);
  }

  /**
   * @param {string} eventLog
   * @private
   */
  static _validate(eventLog) {
    if (!eventLog) {
      logException('EventLogDispatcher: eventLog is required');
      return false;
    }
    if (!AVAILABLE_EVENTS.includes(eventLog)) {
      logException('EventLogDispatcher: event is not existing');
      return false;
    }

    return true;
  }
}

module.exports = { EventLogDispatcher, EVENT_LOG_MISSION_VIEWED };
